import React, { useState } from "react";
import {
  TextField,
  Stack,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
} from "@mui/material";
import { config } from "../../config";

export default function FilterHero({
  jobLength,
  handleSearch,
  handleFilterChange,
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const [jobType, setJobType] = useState("All");

  const handleInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleJobTypeChange = (event) => {
    setJobType(event.target.value);
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    handleSearch(searchTerm, jobType);
  };

  return (
    <div className="filter-hero">
      <div className="contained">
        <h1 className="h2">Sök bland {jobLength} jobb</h1>
        <form onSubmit={handleFormSubmit}>
          <Stack
            className="search-wrapper"
            width="100%"
            gap="10px"
            direction="row"
            sx={{
              flexDirection: { xs: "column", md: "row" },
            }}
          >
            <input
              type="text"
              placeholder="Sök efter jobb.."
              className="search-input"
              value={searchTerm}
              onChange={handleInputChange}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              startIcon={
                <img src="/assets/icons/search.svg" alt="search icon" />
              }
              sx={{
                height: { xs: "fit-content", md: "100%" },
                // mb: 2,
                borderRadius: "10px",
                padding: "16px 25px",
                fontWeight: "600",
                width: { xs: "100%", md: "fit-content" },
                backgroundColor: config.colors.secondary,
                color: config.colors.white,
                transition: "background-color 500ms, color 500ms",
                "&:hover": {
                  background: config.colors.secondary,
                  color: config.colors.white,
                },
                ":disabled": {
                  backgroundColor: "white",
                  opacity: 0.7,
                },
              }} // Disable button when loading
            >
              Sök {/* Change button text based on loading state */}
            </Button>
          </Stack>
        </form>
        <Stack direction="row" marginTop="20px" gap={2}>
          <select
            onChange={handleFilterChange}
            name="typeOfContract"
            style={{
              width: "50%",
              padding: "16px 25px",
            }}
          >
            <option value="">Alla</option>
            <option value="Full Time">Heltid</option>
            <option value="Part Time">Deltid</option>
            <option value="Time contract">Kontrakt</option>
          </select>
          <select
            onChange={handleFilterChange}
            name="published"
            style={{
              width: "50%",
            }}
          >
            <option value="">Datum</option>
            <option value="Today">Idag</option>
            <option value="Last 7 days">Senaste 7 dagarna</option>
            <option value="Last 30 days">Senaste 30 dagarna</option>
          </select>
        </Stack>
      </div>
    </div>
  );
}
